<template>
      <div class="choice">

        <div class="forca_parte">
                <div class="logo">     
                     <img class="imagem_relate" src="/jogo-da-forca/images/ayurveda.png" />
                </div>
                <div class="titulo">
                    <h1>Modo de jogo</h1> 
                </div>    
          </div>
        <button @click="song" v-on:click="StartOnly" class="btn" id="inicio" value="inicio">Jogar solo</button>
        <button @click="song" id="modo" v-on:click="startWithFriend" class="btn" value="escolherDica">Desafiar amigo</button>
     </div>
</template>
<script>

export default{
    name:'MododeJogo',
    props:{
        EscolherModo: Function,
    },
    methods:{
        StartOnly(){ 
         var Modo = document.getElementById("modo").value
         this.EscolherModo(Modo,Modo)
        },
        startWithFriend(){
        var palavra = 'palavra'
        var inicio = document.getElementById("inicio").value
        this.EscolherModo(inicio,palavra);
        },
         song(){
            var click = new Audio('./songs/click.mp3');
            click.play();
        },
    },
}
</script>


<style scoped>
.imagem_relate{
    position: relative;
    top:-70px;
}
.choice{
    display:flex;
    align-items: center;
    justify-content: center;
}
.btn{
    outline: none;
    width: 300px;
    background:linear-gradient(150deg,rgba(57, 6, 78, 0.274),rgba(0,0,0,1));
}

.btn::before{
    background:linear-gradient(150deg,rgb(5, 184, 216),rgba(20,200,32,0.8));
}

.forca_parte{
      animation:animar infinite 3s alternate-reverse;
}
@keyframes animar{
    to{
        transform: scale(1);
    }from{
        transform: scale(0.9);
    }
}
.forca_parte{
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
h1{
    display:flex;
    align-items: center;
    padding:2px 0;
    font-weight: bold;
    font-size: 41px;
    display:flex;
    align-items: center;
    text-shadow:rgb(238, 0, 0);
    color:rgb(114, 245, 38);
    letter-spacing: 5px;
}
    @media (max-width:450px){
     h1{
         font-size: 28px; 
     }

    .forca_parte{     
        position:relative;
        top:15px;
     }
     
    }


@media (max-width:350px){
.btn{
    width: 95%;
}
}
</style>